<template>
  <z-card class="widget-nota-quero">
    <z-title
      size="small"
      class="widget-nota-quero__title"
    >
      {{ $t('title') }}
    </z-title>

    <z-text
      tag="p"
      class="widget-nota-quero__paragraph"
    >
      {{ $t('paragraph') }}
    </z-text>

    <VLazyImage
      :alt="$t('figure-alt')"
      :src="$asset('/cdn/pi04aa00od_001.svg', { source: 'imageboss' })"
      class="widget-nota-quero__illustration"
    />

    <ul class="widget-nota-quero__feature">
      <li
        v-for="feature in features"
        :key="feature.title"
        class="widget-nota-quero__feature-wrapper"
      >
        <z-icon
          class="widget-nota-quero__feature-icon"
          :icon="feature.icon"
        />

        <z-title
          size="nano"
          weight="bold"
          class="widget-nota-quero__feature-title"
        >
          {{ feature.title }}
        </z-title>

        <z-text
          v-if="feature.description"
          tag="span"
          class="widget-nota-quero__feature-description"
        >
          {{ feature.description }}
        </z-text>
      </li>
    </ul>

    <div class="widget-nota-quero__footer">
      <z-button
        class="widget-nota-quero__cta-button"
        href="https://avaliacao.querobolsa.com.br/cadastro"
        variant="secondary"
        tag="a"
      >
        {{ $t('footer-cta-button-text') }}
      </z-button>

      <div class="widget-nota-quero__link-wrapper">
        <z-text
          tag="span"
          size="small"
        >
          {{ $t('footer-text') }}
        </z-text>

        <z-link
          href="/nota-quero"
          size="small"
        >
          {{ $t('footer-link') }}
        </z-link>
      </div>
    </div>
  </z-card>
</template>

<script>
import VLazyImage from 'v-lazy-image/v2'

import { faCircleCheck, faCircleDollar, faGlobe } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'WidgetNotaQuero',
  components: {
    VLazyImage,
  },

  data () {
    return {
      features: [
        {
          icon: faGlobe,
          title: '100% online',
          description: 'Entre na faculdade sem sair de casa.',
        },
        {
          icon: faCircleDollar,
          title: 'É grátis!',
          description: 'Garanta sua aprovação antes de escolher sua bolsa.',
        },
        {
          icon: faCircleCheck,
          title: 'A Nota é aceita em mais de 100 faculdades',
        },
      ],
    }
  },

  i18n: {
    messages: {
      'pt-BR': require('./i18n/widget-nota_quero.json'),
    },
  },
}
</script>

<style lang="scss" scoped>
.widget-nota-quero {
  align-items: center;
  display: grid;
  grid-template-areas:
    (
      'title'
      'paragraph'
      'illustration'
      'feature'
      'footer'
    );
  grid-template-columns: 1fr;

  @media (min-width: $breakpoint-desktop) {
    grid-template-areas:
      (
        'title     title'
        'paragraph paragraph'
        'feature   illustration'
        'footer    illustration'
      );
    grid-template-columns: 2.5fr 1fr;
  }
}

.widget-nota-quero__title {
  grid-area: title;
}

.widget-nota-quero__paragraph {
  grid-area: paragraph;
  margin-bottom: var(--unit-0000);
  margin-top: var(--unit-0200);
}

.widget-nota-quero__illustration {
  height: 190px;
  width: 218px;
  grid-area: illustration;
  margin-left: auto;
  margin-right: auto;
  margin-top: var(--unit-0200);
  max-width: 290px;

  @media (min-width: $breakpoint-desktop) {
    margin-top: var(--unit-0000);
  }
}

.widget-nota-quero__feature {
  display: grid;
  grid-area: feature;
  margin-bottom: var(--unit-0000);
  margin-top: var(--unit-0200);
  padding-left: var(--unit-0000);
  row-gap: var(--unit-0400);

  @media (min-width: $breakpoint-desktop) {
    margin-top: var(--unit-0800);
  }
}

.widget-nota-quero__feature-wrapper {
  column-gap: var(--unit-0100);
  display: grid;
  grid-auto-rows: repeat(2, auto);
  grid-template-areas:
    (
      'icon title'
      'icon description'
    );
  grid-template-columns: var(--unit-0500) 1fr;
}

.widget-nota-quero__feature-icon {
  grid-area: icon;
}

.widget-nota-quero__feature-title {
  grid-area: title;
}

.widget-nota-quero__feature-description {
  grid-area: description;
}

.widget-nota-quero__footer {
  column-gap: var(--unit-0800);
  display: grid;
  grid-area: footer;
  grid-template-areas:
    (
      'cta-button'
      'link-wrapper'
    );
  margin-top: var(--unit-0800);
  row-gap: var(--unit-0400);

  @media (min-width: $breakpoint-desktop) {
    grid-template-areas:
      (
        'cta-button link-wrapper'
      );
    grid-template-columns: repeat(2, max-content);
  }
}

.widget-nota-quero__cta-button {
  grid-area: cta-button;
}

.widget-nota-quero__link-wrapper {
  display: flex;
  flex-direction: column;
  grid-area: link-wrapper;
}
</style>
